module.exports = __webpack_public_path__ + "static/img/logo_collapse.3c82696.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_collapse.png
// module id = izXM
// module chunks = 11